import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid2, Typography, TextField, Button } from "@mui/material";
import * as yup from "yup";
import { isEmpty } from "lodash";
import { useFormik } from "formik";
import Layout from "../Layout";
import GeneralHeader from "../../components/GeneralHeader";
import Footer from "../../components/Footer";
import { PAGE_LIST } from "../index";
import { selectLoggedIn } from "../../store/userSlice/userSelectors";
import { sendResetPassword } from "../../store/userSlice/userRequests";

import classes from './index.module.scss';

const RequestResetPasswordPage = () => {
  const isLoggedIn = useSelector(selectLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSent, setIsSent] = useState(false);

  const validationSchema = yup.object({
    email: yup.string().email('Invalid email format').required("Email is required"),
  });

  const resetFormik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: () => {},
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  useEffect(() => {
    if (isLoggedIn) {
      navigate(PAGE_LIST.CERTIFICATE)
    }
  }, [isLoggedIn]);

  const onSubmit = async () => {
    const errorList = await resetFormik.validateForm();

    if (isEmpty(errorList)) {
      dispatch(sendResetPassword(resetFormik.values))
        .then((action) => {
          const errorText = action?.payload?.message;

          if (errorText) {
            resetFormik.setErrors({
              email: errorText,
            })
          } else {
            setIsSent(true);
          }
        })
    }
  }

  return (
    <Layout
      header={<GeneralHeader />}
      center={(
        <Grid2
          container
          direction="column"
          className={classes.container}
          spacing={2}
        >
          <Grid2 size={12} className={classes.width}>
            <Typography variant='h1' align='center'>Reset your password</Typography>
          </Grid2>
          {
            isSent ? (
              <Grid2>
                <Typography variant='body1'>Your password has been reset. Check your email inbox</Typography>
              </Grid2>
            ) : (
              <>
                <Grid2 size={12} className={classes.width}>
                  <Typography variant='body1'>Email</Typography>
                  <TextField
                    variant='outlined'
                    name='email'
                    size='medium'
                    fullWidth
                    value={resetFormik.values?.email}
                    onChange={resetFormik.handleChange}
                    error={Boolean(resetFormik?.errors?.email)}
                    helperText={resetFormik?.errors?.email}
                  />
                </Grid2>
                <Grid2 size={12} className={classes.width}>
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth
                    onClick={onSubmit}
                  >
                    Reset
                  </Button>
                </Grid2>
              </>
            )
          }
        </Grid2>
      )}
      footer={<Footer />}
    />
  )
}

export default RequestResetPasswordPage;